export const maxStudyAdditionalSections = 10;
export const maxStudySectionImages = 5;
export const minPasswordLength = 8;
export const passwordExpiryInDays = 180;
export const defaultPageSize = 100;
